webpackJsonp([44798033095983],{

/***/ 1653:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AppointmentReasonCategory","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"reason","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-appointment-reason-category-1a97379e45d25dbbc0c8.js